// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d19677d","453":"166346ad","535":"4e3e0d3d","977":"297b5374"}[chunkId] + ".chunk.js";
};